import { Container } from 'reactstrap';
import {
  Glyphicon as MenuListGlyphicon,
  MenuItem,
  MenuLink
} from '../MenuList/MenuList.style';
import { lineSeparatorGray } from 'components/style/Colors.style';
import styled from 'styled-components';

// The padding acquired from py-3 class but without the `!important`
const py3Padding = '1.5rem';
export const TakeTourContainer = styled(Container).attrs({
  className: 'pl-4 py-3'
})``;

export const LineSeparator = styled.div`
  border-top: solid 2px ${lineSeparatorGray};
  margin-bottom: ${py3Padding};
`;

export const TakeTourItem = styled(MenuItem)``;

export const TakeTourLink = styled(MenuLink)``;

export const Glyphicon = MenuListGlyphicon;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/TakeTour/TakeTour.style.js